import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M24 6.843c0-.586-.4-.977-1-.977s-1 .39-1 .977v3.52l-7.8-7.626a.98.98 0 0 0-1.4 0L8.5 6.941 1.7.293a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.37l7.5 7.331c.4.39 1 .39 1.4 0l4.3-4.204 7.1 6.941H17c-.6 0-1 .391-1 .978 0 .586.4.977 1 .977h6c.1 0 .3 0 .4-.098.2-.097.4-.293.5-.488.1-.098.1-.294.1-.39z"
    }, null, -1)
  ]))]))
}
export default { render: render }